import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import PaywallPage from "@/pages/PaywallPage";

export default function ProtectedRoute({ children, allowPaywall = false }) {
  const { user, billing } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-slate-50">
        <div className="text-sm text-slate-500" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;

  // If the paywall is triggered, block everything except the settings route
  // (users still need Settings access to manage billing after checkout return).
  if (billing && !billing.can_access_dashboard && !allowPaywall) {
    const onSettings = location.pathname.startsWith("/dashboard/settings");
    if (!onSettings) return <PaywallPage />;
  }
  return children;
}
